import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import {
  Box,
  Button,
  Container,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useInitProvider } from 'providers/InitProvider';
import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { workspacePostCall } from '.';
import TitleWorkspace from './TitleWorkspace';

const Workspace = () => {
  const theme = useTheme();
  const smMediaQuery = useMediaQuery(theme.breakpoints.down('sm'));
  const initData = useInitProvider();
  const { dump } = initData;
  const available = dump?.workspace.available?.sort((a, b) =>
    a.name.localeCompare(b.name),
  );
  const { user } = dump;
  const { t } = useTranslation();
  const [filteredWorkspaces, setFilteredWorkspaces] = useState(available);

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const f = available.filter((item) =>
      // `${item.name} ${item.description}`
      item.name.toLowerCase().includes(e.currentTarget.value.toLowerCase()),
    );

    setFilteredWorkspaces(f);
  };

  const handleSelectWorkout = (code) => {
    console.log('POST AL BACKEND con il code: ' + code);
    workspacePostCall(code);
  };

  return (
    <div style={{ backgroundColor: 'rgb(228, 231, 233)', overflowY: 'auto' }}>
      <Container
        maxWidth="xl"
        sx={{
          height: 'calc(100vh - 72px)',
        }}
      >
        <Box sx={{ height: '100%', width: '100%', pt: '2rem' }}>
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            sx={{ height: '100%', width: '100%' }}
          >
            <Stack
              flexWrap="wrap"
              direction="row"
              gap="1rem"
              width="100%"
              alignItems="center"
              paddingBottom="1rem"
              borderBottom="2px solid lightgray"
            >
              <TitleWorkspace t={t} user={user} smMediaQuery={smMediaQuery} />
              <TextField
                onChange={handleSearchChange}
                sx={{ ...(smMediaQuery && { flexGrow: 1 }) }}
                placeholder={t('search')}
                InputProps={{
                  sx: {
                    ...(!smMediaQuery && { width: '20em' }),
                    paddingLeft: 0,
                    height: smMediaQuery ? '2.5em' : '3em',
                  },
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchRoundedIcon />
                    </InputAdornment>
                  ),
                }}
              ></TextField>
            </Stack>
            <div
              style={{
                display: 'grid',
                ...(!smMediaQuery && { gridTemplateColumns: 'repeat(2, 1fr)' }),
                gap: '1rem',
                width: '100%',
                paddingBottom: '1em',
              }}
            >
              {filteredWorkspaces.map((workspace) => (
                <Button
                  disableFocusRipple
                  disableTouchRipple
                  sx={{
                    backgroundColor: 'white',
                    justifyContent: 'space-between',
                    height: '3.5em',
                    boxShadow: 3,
                    '&:hover': {
                      backgroundColor: 'white',
                    },
                  }}
                  disableRipple
                  onClick={() => handleSelectWorkout(workspace.code)}
                >
                  <Tooltip
                    // title={`${workspace.name} ${workspace.description}`}
                    title={workspace.name}
                    enterDelay={1000}
                  >
                    <Typography
                      whiteSpace="nowrap"
                      overflow={'hidden'}
                      variant="body1"
                      component="div"
                      textOverflow={'ellipsis'}
                    >
                      <>
                        {workspace.name}
                        {/* {workspace.description && ' - ' + workspace.description} */}
                      </>
                    </Typography>
                  </Tooltip>
                  <ChevronRightRoundedIcon
                    sx={{
                      color: 'gray',
                      marginRight: '-0.5em',
                    }}
                  />
                </Button>
              ))}
            </div>
          </Stack>
        </Box>
      </Container>
    </div>
  );
};

export default Workspace;
